export default __webpack_public_path__ + "static/alex&natalia-8d66ce44bbeb0cfaa70d1236db4cf1ce.jpg";